import { PureComponent, Fragment } from 'react';
import { withTranslation, Trans } from 'react-i18next';
import { Segment, Grid } from 'semantic-ui-react';

import {
  map,
  findIndex,
  capitalize,
  isEmpty,
  uniq,
} from '../../../utils/lodash';

import { ContentAndHeader, setParentDomains } from '../../../utils';
import { formatList } from '../../../i18n';
import { isParentProgramActivity } from '../../../utils/activity';

import './activity.scss';

class TheoryOfChange extends PureComponent {
  render() {
    const {
      grant = false,
      description,
      aim,
      knowing,
      willDo,
      currentActivity,
      t,
    } = this.props;

    // primary domain first, then the rest ,de-dupe the primary
    const domainNames =
      !isEmpty(currentActivity) &&
      isParentProgramActivity(currentActivity.activityPlanTypeId)
        ? uniq(
            map(setParentDomains(currentActivity), (d) => d.policy.policyName)
          )
        : [];
    const [primaryDomain, ...secondaryDomains] = domainNames;

    return (
      <Segment className="report-activity-seg">
        <div className="report-activity-div">
          {grant ? (
            <Fragment>
              <Grid className="report-theory-grid">
                <Grid.Row className="row-spacing">
                  <Grid.Column
                    className="col-spacing"
                    mobile={16}
                    tablet={16}
                    computer={16}
                  >
                    <div className="primary-title">
                      {t('activity.theory_of_change.primary_domain')}
                    </div>
                    <div className="header-spacing">{primaryDomain || '-'}</div>
                  </Grid.Column>
                </Grid.Row>
                {!isEmpty(secondaryDomains) && (
                  <Grid.Row className="row-spacing">
                    <Grid.Column
                      className="col-spacing"
                      mobile={16}
                      tablet={16}
                      computer={16}
                    >
                      <div className="secondary-title">
                        {t('activity.theory_of_change.secondary_domain', {
                          count: secondaryDomains.length,
                        })}
                      </div>
                      <div className="header-spacing">
                        {formatList(secondaryDomains)}
                      </div>
                    </Grid.Column>
                  </Grid.Row>
                )}
                <Grid.Row className="row-spacing">
                  <Grid.Column
                    className="theory-col-spacing"
                    mobile={16}
                    tablet={16}
                    computer={12}
                  >
                    <div className="header-spacing-no-margin">
                      {t('common.theory_of_change')}
                    </div>
                    <div>
                      <p className="toc-line">
                        {isEmpty(domainNames) ? (
                          <Trans i18nKey="activity.theory_of_change.we_are_aiming_for_outcomes_in_no_selected_domains" />
                        ) : (
                          <Trans
                            i18nKey="activity.theory_of_change.we_are_aiming_for_outcomes_in_the_selected_domains"
                            count={domainNames.length}
                            values={{ domains: domainNames }}
                          />
                        )}
                      </p>
                      <p className="toc-line">
                        <strong>{t('common.we_know_that')}</strong>{' '}
                        {knowing || '-'}
                      </p>
                      <p className="toc-line">
                        <strong>{t('common.therefore_we_will')}</strong>{' '}
                        {willDo || '-'}
                      </p>
                    </div>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Fragment>
          ) : (
            <Fragment>
              <Grid>
                <Grid.Row>
                  <p className="info-desc-sixteen">
                    {description ? capitalize(description) : '-'}
                  </p>
                </Grid.Row>

                <Grid.Row className="intended-outcomes-row-spacing">
                  <Grid.Column
                    mobile={16}
                    tablet={14}
                    computer={12}
                    className="intended-outcomes-col-spacing"
                  >
                    <ContentAndHeader title={t('common.theory_of_change')}>
                      <div className="theory-of-change-report-objective">
                        <p className="toc-line">
                          <strong>{t('common.we_are_aiming_for')}</strong>{' '}
                          {aim || '-'}
                        </p>
                        <p className="toc-line">
                          <strong>{t('common.we_know_that')}</strong>{' '}
                          {knowing || '-'}
                        </p>
                        <p className="toc-line">
                          <strong>{t('common.therefore_we_will')}</strong>{' '}
                          {willDo || '-'}
                        </p>
                      </div>
                    </ContentAndHeader>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Fragment>
          )}

          <Grid>
            <Grid.Row>
              <Grid.Column
                className={grant ? 'evidence-types-used-grants-col' : ''}
              >
                <ContentAndHeader
                  title={t('activity.theory_of_change.evidence_types_used')}
                />
                {this.getEvidence()}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
      </Segment>
    );
  }

  getEvidence() {
    let types = this.props.evidenceTypes;
    let evidence = this.props.evidence;
    let usedTypes = [];

    types.forEach((element) => {
      const isUsed =
        findIndex(evidence, { evidenceType: parseInt(element.id) }) >= 0;

      // "Data" has been retired as an option for new evidence - only show it
      // in the checklist if an activity actually has some on record already.
      if (!isUsed && element.evidenceType === 'Data') return;

      if (findIndex(usedTypes, { type: element.evidenceType }) === -1) {
        usedTypes.push({
          type: element.evidenceType,
          status: isUsed,
        });
      }
    });

    return map(usedTypes, (item, index) =>
      usedTypes.length - 1 === index ? (
        <div className="info-desc evidence-types-no-margin" key={index}>
          {item.status ? (
            <i aria-hidden="true" className="check circle outline icon green" />
          ) : (
            <i aria-hidden="true" className="circle outline icon grey" />
          )}
          <div className="ml-1">{item.type}</div>
        </div>
      ) : (
        <div
          className="info-desc info-desc-last evidence-types-no-margin"
          key={index}
        >
          {item.status ? (
            <i aria-hidden="true" className="check circle outline icon green" />
          ) : (
            <i aria-hidden="true" className="circle outline icon grey" />
          )}
          <div className="ml-1">{item.type}</div>
        </div>
      )
    );
  }
}

TheoryOfChange = withTranslation()(TheoryOfChange);

export { TheoryOfChange };
